import { render, staticRenderFns } from "./page-content-container.vue?vue&type=template&id=2e3e29ee&scoped=true&"
var script = {}
import style0 from "./page-content-container.vue?vue&type=style&index=0&id=2e3e29ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3e29ee",
  null
  
)

export default component.exports